import { AccordionDetails, AccordionSummary, Checkbox, Divider, FormControlLabel, Typography } from "@material-ui/core";
import { ExpandLess } from "@material-ui/icons";
import clsx from "clsx";
import { useEffect, useState } from "react";

import MarkerArchiveCabinet from "@/assets/img/map/MarkerArchiveCabinet.svg";
import MarkerDeactivated from "@/assets/img/map/MarkerDeactivated.svg";
import MarkerLiveUnit from "@/assets/img/map/MarkerLiveUnit.svg";
import { Accordion, useStyles } from "@/common/components/MapLandingPage/Filters/FiltersStyles";
import { useDispatch, RootState, useSelector } from "@/store/index";
import { setAllFilter, setArchiveCabinetFilter, setDeactivatedFilter, setLiveUnitFilter } from "@/store/map/slice";
import * as FullStory from "@/utilities/hooks/fullstory";


export default function Filters() {

    const all: boolean = useSelector((state: RootState) => state.map.allFilter);
    const archiveCabinet: boolean = useSelector((state: RootState) => state.map.archiveCabinetFilter);
    const deactivated: boolean = useSelector((state: RootState) => state.map.deactivatedFilter);
    const liveUnit: boolean = useSelector((state: RootState) => state.map.liveUnitFilter);
    const [isExpanded, setIsExpanded] = useState<boolean>(false);

    const classes = useStyles();

    const dispatch = useDispatch();

    useEffect(() => {
        if (deactivated && liveUnit && archiveCabinet) {
            dispatch(setAllFilter(true));
        } else {
            dispatch(setAllFilter(false));
        }
    }, [deactivated, liveUnit, archiveCabinet]);

    const handleVisibility = () => setIsExpanded((state) => !state);

    return (
        <Accordion id="map-filters" data-testid="map-filters" square expanded={isExpanded} className={FullStory.names.classes.map.filterMenu} onChange={() => handleVisibility()}>
            <AccordionSummary className={classes.base} expandIcon={<ExpandLess />}>
                <Typography className={classes.filterLabel}>Filters</Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.filters}>
                <FormControlLabel
                    control={
                        <Checkbox
                            onChange={(e) => {
                                dispatch(setArchiveCabinetFilter(e.target.checked));
                                dispatch(setDeactivatedFilter(e.target.checked));
                                dispatch(setLiveUnitFilter(e.target.checked));
                            }}
                            checked={all}
                            className={clsx(classes.filterCheckbox, FullStory.names.classes.map.filterToggle)}
                            color="default"
                        />
                    }
                    label={<Typography className={classes.filterLabel}>All</Typography>}
                />
                <Divider className={classes.divider} />
                <FormControlLabel
                    control={
                        <Checkbox
                            onChange={(e) => {
                                dispatch(setArchiveCabinetFilter(e.target.checked));
                            }}
                            checked={archiveCabinet}
                            className={clsx(classes.filterCheckbox, FullStory.names.classes.map.filterToggle)}
                            color="default"
                        />
                    }
                    label={
                        <div className={classes.filterLabel}>
                            <img src={MarkerArchiveCabinet} className={classes.filterIcon} />
                            <Typography>Archive Cabinet</Typography>
                        </div>
                    }
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            onChange={(e) => {
                                dispatch(setDeactivatedFilter(e.target.checked));
                            }}
                            checked={deactivated}
                            className={clsx(classes.filterCheckbox, FullStory.names.classes.map.filterToggle)}
                            color="default"
                        />
                    }
                    label={
                        <div className={classes.filterLabel}>
                            <img src={MarkerDeactivated} className={classes.filterIcon} />
                            <Typography>Deactivated</Typography>
                        </div>
                    }
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            onChange={(e) => {
                                dispatch(setLiveUnitFilter(e.target.checked));
                            }}
                            checked={liveUnit}
                            className={clsx(classes.filterCheckbox, FullStory.names.classes.map.filterToggle)}
                            color="default"
                        />
                    }
                    label={
                        <div className={classes.filterLabel}>
                            <img src={MarkerLiveUnit} className={classes.filterIcon} />
                            <Typography>Live Unit</Typography>
                        </div>
                    }
                />
            </AccordionDetails>
        </Accordion>
    );
}
